<template>
  <div class="rightaside_content">
    <h3 class="headerTitle">商品评价</h3>
    <el-tabs v-model="activeName">
      <el-tab-pane label="待评价" lazy>
        <span slot="label">待评价</span>
        <order-list evaluationFlag="N"></order-list>
      </el-tab-pane>
      <el-tab-pane label="已评价" lazy>
        <span slot="label">已评价</span>
        <order-list evaluationFlag="Y"></order-list>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import OrderList from '../../../components/goodsAppraisalOrder';
export default {
  name: 'goodsAppraisal',
  data() {
    return {
      activeName: '0'
    };
  },
  components: {OrderList}
};
</script>

<style scoped lang="less">
.headerTitle {
  font-size: 20px;
  color: #666;
}
</style>







// WEBPACK FOOTER //
// src/views/myOrder/evaluationePage/goodsAppraisal.vue